export * from './patient-diagnosis-information.component';